import React from 'react'
import Breadcumb from '../../Breadcumb/Main'
import ServiceSidebar from '../ServiceSidebar/Main'
import BgImg from "../../../assets/images/work.jpg"
import QAImg from "../../../assets/images/services/qa-testing-illustration.svg"

const QATesting = () => {
	return (
		<>
			<Breadcumb Title="QA Testing" Breadcumb="SERVICES" BgImg={BgImg} Extra={{backgroundPosition: 'center center'}}/>
			<section className="section-padding--bottom section-padding--top service-details--page">
				<div className="container">
					<div className="row ">
						<div className="col-lg-8">
							<div className="service-details__image">
								<img src={QAImg} alt="Software quality assurance: bug inspection under a magnifying glass and a passing test checklist" />
							</div>
							<h3 className="service-details__title">QA & Testing</h3>
							<div className="service-details__content">
								<p>Quality is not a phase at the end of a project — it is built in from the start. Our QA consultants help teams ship with confidence, from exploratory and functional testing to fully automated test suites integrated into your CI/CD pipeline. Pragmatic in approach, with respect for the balance between cost, time and quality.</p>

								<ul className="service-details__caption__list">
									<li>
										<i className="fa fa-check-circle"></i>
										Manual, exploratory and functional testing
									</li>
									<li>
										<i className="fa fa-check-circle"></i>
										Test automation for web, mobile and APIs
									</li>
									<li>
										<i className="fa fa-check-circle"></i>
										Performance and load testing
									</li>
									<li>
										<i className="fa fa-check-circle"></i>
										QA strategy, processes and tooling
									</li>
								</ul>

								<div className="service-details__content"/>

								<p>
									Consulting roles: QA engineer, test automation engineer, QA lead
								</p>
							</div>
						</div>
						<div className="col-lg-4 sidebar-column">
							<ServiceSidebar />
						</div>
					</div>
				</div>
			</section>
		</>)
}

export default QATesting
